import React, { useCallback } from 'react';
import classNames from 'classnames/bind';

// Component
import { Text, Button } from '@beef/ui-kit';
import { I18n } from 'components';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const ErrorPage = () => {
  const handleReloadBtnClick = useCallback(() => window.location.reload(), []);

  return (
    <div className={cn('wrapper')}>
      <div className={cn('image-wrapper')}>
        <img
          className={cn('image')}
          src="https://static.beeline.ru/upload/images/b2c/family-with-beeline/delete-child-number.svg"
          alt="произошла ошибка"
        />
      </div>
      <div className={cn('title')}>
        <Text size="size2-m" tagType="h3">
          <I18n path="family.errorPage.title" />
        </Text>
      </div>
      <div className={cn('description')}>
        <Text size="size4-r" color="grey50">
          <I18n path="family.errorPage.description" />
        </Text>
      </div>
      <Button
        variant="tertiary"
        size="m"
        onClick={handleReloadBtnClick}
      >
        <I18n path="family.errorPage.buttonText" />
      </Button>
    </div>
  );
};

export { ErrorPage };
